import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { carRentalDoctypes } from './doctypes'

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'CarFront'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.CAR_RENTAL,
  displayName: 'Car Rental',
  label: 'ระบบเช่ารถ',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.3.0',
  dependencies: [MODULES.CORE, MODULES.ACCOUNTING, MODULES.FLEET],
  category: 'operations',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'เช่ารถ',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'จัดการ',
        items: [
          { label: 'แดชบอร์ด', path: '/car-rental/dashboard', icon: 'LayoutDashboard', exact: true },
          { label: 'การจอง', path: '/car-rental/bookings', icon: 'CalendarCheck' },
          { label: 'รถเช่า', path: '/car-rental/vehicles', icon: 'CarFront' },
          { label: 'ลูกค้า', path: '/car-rental/customers', icon: 'Users' },
        ],
      },
      {
        label: 'ดำเนินการ',
        items: [
          { label: 'รับรถ', path: '/car-rental/pickups', icon: 'FileOutput' },
          { label: 'คืนรถ', path: '/car-rental/returns', icon: 'RotateCcw' },
        ],
      },
      {
        label: 'รายงาน',
        items: [
          { label: 'รายได้', path: '/car-rental/reports/revenue', icon: 'DollarSign' },
          { label: 'สถานะการจอง', path: '/car-rental/reports/bookings', icon: 'ClipboardList' },
          { label: 'การใช้งานรถ', path: '/car-rental/reports/vehicles', icon: 'Gauge' },
          { label: 'สาขา', path: '/car-rental/reports/branches', icon: 'Building2' },
          { label: 'ลูกค้า', path: '/car-rental/reports/customers', icon: 'Users' },
          { label: 'ค่าปรับ', path: '/car-rental/reports/penalties', icon: 'AlertTriangle' },
          { label: 'สรุปการเงิน', path: '/car-rental/reports/financial', icon: 'Calculator' },
          { label: 'ภาพรวมผู้บริหาร', path: '/car-rental/reports/executive', icon: 'LayoutDashboard' },
        ],
      },
      {
        label: 'ตั้งค่า',
        items: [
          { label: 'ตั้งค่าเช่ารถ', path: '/car-rental/settings', icon: 'Settings' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "booking", label: "การจอง", type: "submittable", branchScope: { type: "multi-field", fields: ["pickupBranchId", "returnBranchId"], createField: "branchId" } },
    { key: "releases", label: "รับรถ", branchScope: { type: "inherit" } },
    { key: "returns", label: "คืนรถ", branchScope: { type: "inherit" } },
    { key: "vehicles", label: "รถเช่า" },
    { key: "settings", label: "ตั้งค่า" },
    { key: "reports", label: "รายงาน" },
    { key: "damage-charges", label: "ค่าเสียหาย" },
  ],
  availableHooks: [
    { event: "car-rental.action.confirmBooking", label: "ยืนยันการจอง" },
    { event: "car-rental.action.receiveDeposit", label: "รับมัดจำ" },
    { event: "car-rental.action.releaseVehicle", label: "รับรถ" },
    { event: "car-rental.action.returnVehicle", label: "คืนรถ" },
    { event: "car-rental.action.refundSecurity", label: "คืนเงินประกัน" },
    { event: "car-rental.action.closeBooking", label: "ปิดงาน" },
    { event: "car-rental.action.cancelBooking", label: "ยกเลิกการจอง" },
  ],
  customForms: [
    { key: "car-rental.confirm-booking", label: "ยืนยันการจอง (สร้างใบแจ้งหนี้)" },
    { key: "car-rental.deposit-payment", label: "รับมัดจำ" },
    { key: "car-rental.release-vehicle", label: "รับรถ" },
    { key: "car-rental.return-vehicle", label: "คืนรถ" },
    { key: "car-rental.refund-security", label: "คืนเงินประกัน" },
    { key: "car-rental.close-booking", label: "ปิดงาน" },
    { key: "car-rental.cancel-booking", label: "ยกเลิกการจอง" },
  ],

  extendSchemas: {
    'accounting.invoices': {
      rentalBookingId: 'text',
    },
    'accounting.payments': {
      rentalBookingId: 'text',
      rentalPaymentType: 'text',
    },
  },

  fixtures: [
    { file: 'roles.json', doctype: 'role' },
    { file: 'items.json', doctype: 'item' },
  ],

  moduleMigrations: migrations,

  registeredDoctypes: carRentalDoctypes,
})
